export default "__VITE_ASSET__CVJZYYvg__"